// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".topbar .dropdown-toggle{padding:0}.topbar .dropdown-toggle:hover{text-decoration:none}.topbar .dropdown-toggle.dropdown-toggle-no-caret:after{content:none}.topbar .dropdown-menu{margin:0;padding:0;outline:none}.topbar .dropdown-menu .b-dropdown-text{padding:0}", ""]);
// Exports
module.exports = exports;
